(() => {
  if (window.WoollySizeGuide) return;

  const STORAGE_KEY = 'woolly:size-guide-unit';
  const VALID_UNITS = ['in', 'cm'];

  const getSavedUnit = () => {
    try {
      const unit = window.localStorage.getItem(STORAGE_KEY);
      return VALID_UNITS.includes(unit) ? unit : 'in';
    } catch (error) {
      return 'in';
    }
  };

  const saveUnit = (unit) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, unit);
    } catch (error) {
      // Storage can be unavailable in private browsing; the toggle still works.
    }
  };

  const inchesToCentimeters = (value) => {
    return value.replace(/\d+(?:\.\d+)?/g, (number) => {
      return Math.round(Number.parseFloat(number) * 2.54);
    });
  };

  const prepareCentimeterValues = (guide) => {
    guide.querySelectorAll('[data-inch-value]').forEach((cell) => {
      const centimeterElement = cell.querySelector('[data-unit-value="cm"]');
      if (!centimeterElement || cell.dataset.centimeterValue) return;

      const inchValue = cell.dataset.inchValue || '';
      centimeterElement.textContent =
        cell.dataset.convertUnits === 'true' ? inchesToCentimeters(inchValue) : inchValue;
    });
  };

  const setUnit = (guide, unit, persist = false) => {
    const selectedUnit = VALID_UNITS.includes(unit) ? unit : 'in';
    prepareCentimeterValues(guide);

    guide.querySelectorAll('[data-unit-value]').forEach((value) => {
      value.hidden = value.dataset.unitValue !== selectedUnit;
    });

    guide.querySelectorAll('[data-size-guide-units] input').forEach((input) => {
      input.checked = input.value === selectedUnit;
    });

    guide.dataset.activeUnit = selectedUnit;
    if (persist) saveUnit(selectedUnit);
  };

  const initializeGuide = (guide) => {
    if (guide.dataset.sizeGuideInitialized === 'true') return;
    guide.dataset.sizeGuideInitialized = 'true';
    setUnit(guide, getSavedUnit());
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('.size-guide').forEach(initializeGuide);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-size-guide-units] input');
    if (!input) return;

    const guide = input.closest('.size-guide');
    if (!guide) return;

    setUnit(guide, input.value, true);

    document.querySelectorAll('.size-guide').forEach((otherGuide) => {
      if (otherGuide !== guide) setUnit(otherGuide, input.value);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });

  window.WoollySizeGuide = { initializeAll, setUnit };
  initializeAll();
})();
